import React from 'react';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Shaunak Patel',
      position: 'Work Permit',
      image: '/assets/img/sh.jpg',
      text: 'TTS helped me successfully apply for my work visa and guided me throughout my college admission process. Their support was reliable and personal. i had several rejections for Australia and New Zealand.'
    },
    {
      id: 2,
      name: 'Chaitali Shah',
      position: 'Work Permit',
      image: '/assets/img/ch.jpg',
      text: 'I was working as a Maths teacher in government school, at the age of 45 moving to canada seemed impossible but The Trivedi Solutions made everything seamless. Highly recommended!'
    },
    {
      id: 3,
      name: 'Dharmesh Vyas',
      position: 'Permanent Residency',
      image: '/assets/img/testimonial.png',
      text: 'I was struggling with my PR application, but with their professional help, everything got approved smoothly!'
    }
  ];

  return (
    <div className="container-fluid testimonial py-5">
      <div className="container py-5">
        <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="sub-style">
            <h5 className="sub-title text-primary px-3">Testimonial</h5>
          </div>
          <h1 className="display-5 mb-4">What Our Clients Say</h1>
          <p className="mb-0">We take pride in delivering reliable, personalized, and result-driven services. Hear from our satisfied clients who have successfully navigated their immigration and business journeys with our expert guidance.</p>
        </div>
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div key={testimonial.id} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
              <div className="testimonial-item text-center p-4">
                <div className="testimonial-img mb-4">
                  <img src={testimonial.image} className="img-fluid rounded-circle" alt={testimonial.name} />
                </div>
                <div className="testimonial-content">
                  <p className="mb-4">{testimonial.text}</p>
                  <h5 className="mb-1">{testimonial.name}</h5>
                  <span className="text-muted">{testimonial.position}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection; 